import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OwnerProfilePanel = ({ owner, onEdit }) => {
  if (!owner) {
    return (
      <div className="bg-black rounded-lg border border-primary/30 p-8 text-center">
        <Icon name="UserX" size={48} color="var(--color-muted-foreground)" />
        <p className="text-muted-foreground mt-4">اختر مالكاً لعرض التفاصيل</p>
      </div>
    );
  }

  return (
    <div className="bg-black rounded-lg border border-primary/30 overflow-hidden">
      <div className="bg-gradient-to-l from-primary/10 to-secondary/10 p-6 md:p-8">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="relative">
            <Image
              src={owner?.avatar}
              alt={owner?.avatarAlt}
              className="w-20 h-20 md:w-24 md:h-24 rounded-lg object-cover border-4 border-card shadow-warm"
            />
            {owner?.verified && (
              <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-success rounded-full flex items-center justify-center border-4 border-card">
                <Icon name="Check" size={16} color="#FFFFFF" />
              </div>
            )}
          </div>

          <div className="flex-1">
            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 mb-2">
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground">
                {owner?.name}
              </h2>
              <span className="px-3 py-1 rounded-full text-xs font-caption bg-success/10 text-success border border-success/20 w-fit">
                {owner?.status}
              </span>
            </div>
            <p className="text-sm md:text-base text-muted-foreground mb-3">
              {owner?.nationalId}
            </p>
            <div className="flex flex-wrap gap-2">
              <Button
                variant="default"
                size="sm"
                iconName="Edit"
                iconSize={16}
                onClick={onEdit}
              >
                تعديل البيانات
              </Button>
              <Button
                variant="outline"
                size="sm"
                iconName="FileText"
                iconSize={16}
                onClick={() => console.log('Generate report')}
              >
                تقرير المالك
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="p-6 md:p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Phone" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">رقم الهاتف</p>
              <p className="text-sm md:text-base font-data text-foreground" dir="ltr">
                {owner?.phone}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">البريد الإلكتروني</p>
              <p className="text-sm md:text-base text-foreground line-clamp-1">
                {owner?.email}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Building2" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">عدد العقارات</p>
              <p className="text-sm md:text-base font-data font-semibold text-foreground">
                {owner?.propertyCount} عقار
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center flex-shrink-0">
              <Icon name="DollarSign" size={20} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">الإيراد الشهري</p>
              <p className="text-sm md:text-base font-data font-semibold text-success">
                {owner?.totalMonthlyRevenue}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="CreditCard" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">رقم الحساب البنكي</p>
              <p className="text-sm md:text-base font-data text-foreground" dir="ltr">
                {owner?.bankAccount}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Calendar" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">تاريخ التسجيل</p>
              <p className="text-sm md:text-base font-data text-foreground">
                {owner?.registrationDate}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerProfilePanel;